import { Add, Remove } from "@mui/icons-material";
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import { orange } from "@mui/material/colors";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { useContext } from "react";
import { TripContext } from "../ContextProviders/BookingContextProvider";
import DateSelector from "./DateSelector";

const QuickBooking = () => {
  const { t } = useTranslation();
  const { navigate } = useI18next();

  const {
    selectedTrip,
    booking,
    increaseNumberOfChildren,
    decreaseNumberOfChildren,
    increaseNumberOfAdults,
    decreaseNumberOfAdults,
    loadingSlots,
    slots,
    selectedDate,
    selectDate,
  } = useContext(TripContext);

  const formatter = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
  });

  const handleOnSelectedDate = (date: Date) => {
    selectDate(date);
  };

  const handleOnBookItNow = () => {
    navigate("/#booking");
  };

  return (
    <Box>
      <Box
        sx={{
          padding: "10px",
          backgroundColor: orange[600],
          marginBottom: "16px",
          textAlign: "center",
        }}
      >
        <Typography color="white" variant="h5">
          {t("quickbook.booking")}
        </Typography>
      </Box>
      <Grid container sx={{ paddingX: "16px" }}>
        <Grid item xs={6}>
          <Typography variant="h5">
            {selectedTrip ? formatter.format(selectedTrip.pricePerAdult.amount) : formatter.format(0)}
          </Typography>
          <Typography
            variant="body1"
            component="span"
            sx={{
              padding: "5px",
              backgroundColor: "#bbb",
              borderRadius: "10%",
              fontSize: "12px",
            }}
          >
            {t("quickbook.adults")}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Box>
            <IconButton
              sx={{
                color: "white",
                borderRadius: "10%",
                backgroundColor: orange[600],
                "&:hover": { backgroundColor: orange[800] },
              }}
              onClick={() => increaseNumberOfAdults()}
            >
              <Add />
            </IconButton>
            <Typography
              variant="h5"
              sx={{
                display: "inline-block",
                width: "40px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {booking ? booking.numberOfAdults : 0}
            </Typography>
            <IconButton
              sx={{
                color: "white",
                borderRadius: "10%",
                backgroundColor: orange[600],
                "&:hover": { backgroundColor: orange[800] },
              }}
              onClick={() => decreaseNumberOfAdults()}
            >
              <Remove />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <Grid container sx={{ paddingX: "16px", paddingY: "8px" }}>
        <Grid item xs={6}>
          <Typography variant="h5">
            {selectedTrip ? formatter.format(selectedTrip.pricePerChild.amount) : formatter.format(0)}
          </Typography>
          <Typography
            variant="body1"
            component="span"
            sx={{
              padding: "5px",
              backgroundColor: "#bbb",
              borderRadius: "10%",
              fontSize: "12px",
            }}
          >
            {t("quickbook.children")}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Box>
            <IconButton
              sx={{
                color: "white",
                borderRadius: "10%",
                backgroundColor: orange[600],
                "&:hover": { backgroundColor: orange[800] },
              }}
              onClick={() => increaseNumberOfChildren()}
            >
              <Add />
            </IconButton>
            <Typography
              variant="h5"
              sx={{
                display: "inline-block",
                width: "40px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {booking ? booking.numberOfChildren : 0}
            </Typography>
            <IconButton
              sx={{
                color: "white",
                borderRadius: "10%",
                backgroundColor: orange[600],
                "&:hover": { backgroundColor: orange[800] },
              }}
              onClick={() => decreaseNumberOfChildren()}
            >
              <Remove />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <Typography variant="body1" component="span" sx={{ paddingX: "16px" }}>
        {t("quickbook.under-5")}
      </Typography>
      <Box sx={{ paddingX: "16px", paddingTop: "8px" }}>
        <DateSelector
          loadingSlots={loadingSlots}
          selectedDate={selectedDate}
          onSelectedDate={handleOnSelectedDate}
          slots={slots}
          mobile
        />
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography component="span" sx={{ fontSize: "16x", marginRight: "5px" }}>
          {t("quickbook.price")}
        </Typography>
        <Typography component="span" sx={{ fontSize: "40px" }}>
          {selectedTrip && booking
            ? formatter.format(
                booking.numberOfChildren * selectedTrip.pricePerChild.amount +
                  booking.numberOfAdults * selectedTrip.pricePerAdult.amount
              )
            : formatter.format(0)}
        </Typography>
      </Box>
      <Box sx={{ textAlign: "center", paddingBottom: "16px" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: orange[600],
            "&:hover": { backgroundColor: orange[800] },
          }}
          onClick={handleOnBookItNow}
        >
          {t("quickbook.book-it-now")}
        </Button>
      </Box>
    </Box>
  );
};

export default QuickBooking;
